import { trackFormFail, trackFormSuccess } from '../events'
import { checkResponseError } from './checkResponseError'
import {
  postToHubspot,
  postToHubspotV3,
  PostToHubspotV3Props,
} from './postToHubspot'

export type PostToHubspot = {
  firstName: string
  lastName: string
  email: string
  phoneNumber?: string
  organizationName: string
  jobTitle: string
  seats?: number
  useCase: string
  whenAreYouLookingToPurchase?: string
  gdprOptIn: boolean
  employeeSize?: string
}

export const handlePostToHubspot = ({
  email,
  phoneNumber,
  firstName,
  gdprOptIn,
  lastName,
  organizationName,
  jobTitle,
  seats,
  useCase,
  whenAreYouLookingToPurchase,
}: PostToHubspot) =>
  postToHubspot({
    email,
    phoneNumber,
    firstName,
    gdprOptIn,
    lastName,
    organizationName,
    jobTitle,
    seats,
    useCase,
    whenAreYouLookingToPurchase,
  })
    .then((res) => {
      checkResponseError(res)
      // Hubspot Success
      trackFormSuccess({
        firstName,
        lastName,
        email,
        phoneNumber,
        organizationName,
        jobTitle,
        seats,
        useCase,
        whenAreYouLookingToPurchase,
        gdprOptIn,
      })
    })
    .catch((responseError) => {
      // Hubspot Fail
      trackFormFail({
        firstName,
        lastName,
        email,
        phoneNumber,
        organizationName,
        jobTitle,
        seats,
        useCase,
        whenAreYouLookingToPurchase,
        gdprOptIn,
        // List of type errors: https://legacydocs.hubspot.com/docs/methods/forms/submit_form
        //
        // Hubspot's response when a request is badly-formatted:
        // {"status":"error","message":"The request is not valid","correlationId":"6398a2be-577c-40a2-84fc-cb4868a9aa33"}
        //
        // Hubspot's response when a required field is missing:
        // {"status":"error","message":"The request is not valid","correlationId":"e1497452-6e8a-4ae7-953a-21dd3bd9d2e1",
        // "errors":[{"message":"Error in 'fields.email'. Required field 'email' is missing","errorType":"REQUIRED_FIELD"}]}
        //
        // Hubspot's response is tacked into the Error's `response` field
        // See how we manually throw an error inside checkResponseError() above)
        error:
          responseError?.errors
            ?.map(
              (e: { errorType: string; message: string }) =>
                `${e.errorType}: ${e.message}`,
            )
            .join(', ') ||
          responseError?.message ||
          responseError?.status,
      })

      throw responseError
    })

export const handlePostToHubspotV3 = ({
  firstName,
  lastName,
  email,
  jobTitle,
  employeeSize,
  organizationName,
  useCase,
  whenAreYouLookingToPurchase,
  purpose,
  selfServePurchased,
  gdprOptIn,
}: PostToHubspotV3Props) =>
  postToHubspotV3({
    firstName,
    lastName,
    email,
    jobTitle,
    employeeSize,
    organizationName,
    useCase,
    whenAreYouLookingToPurchase,
    purpose,
    selfServePurchased,
    gdprOptIn,
  })
    .then((res) => {
      checkResponseError(res)
      // Hubspot Success
      trackFormSuccess({
        firstName,
        lastName,
        email,
        organizationName,
        jobTitle,
        seats: Number(employeeSize),
        useCase,
        gdprOptIn,
      })
    })
    .catch((responseError) => {
      // Hubspot Fail
      trackFormFail({
        firstName,
        lastName,
        email,
        organizationName,
        jobTitle,
        seats: Number(employeeSize),
        useCase,
        gdprOptIn,
        // List of type errors: https://legacydocs.hubspot.com/docs/methods/forms/submit_form
        //
        // Hubspot's response when a request is badly-formatted:
        // {"status":"error","message":"The request is not valid","correlationId":"6398a2be-577c-40a2-84fc-cb4868a9aa33"}
        //
        // Hubspot's response when a required field is missing:
        // {"status":"error","message":"The request is not valid","correlationId":"e1497452-6e8a-4ae7-953a-21dd3bd9d2e1",
        // "errors":[{"message":"Error in 'fields.email'. Required field 'email' is missing","errorType":"REQUIRED_FIELD"}]}
        //
        // Hubspot's response is tacked into the Error's `response` field
        // See how we manually throw an error inside checkResponseError() above)
        error:
          responseError?.errors
            ?.map(
              (e: { errorType: string; message: string }) =>
                `${e.errorType}: ${e.message}`,
            )
            .join(', ') ||
          responseError?.message ||
          responseError?.status,
      })

      throw responseError
    })
